/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectTypeResource = {
    FixedPrice: 'FIXED_PRICE',
    CostPlus: 'COST_PLUS'
} as const;
export type ProjectTypeResource = typeof ProjectTypeResource[keyof typeof ProjectTypeResource];


export function instanceOfProjectTypeResource(value: any): boolean {
    for (const key in ProjectTypeResource) {
        if (Object.prototype.hasOwnProperty.call(ProjectTypeResource, key)) {
            // @ts-ignore
            if (ProjectTypeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectTypeResourceFromJSON(json: any): ProjectTypeResource {
    return ProjectTypeResourceFromJSONTyped(json, false);
}

export function ProjectTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTypeResource {
    return json as ProjectTypeResource;
}

export function ProjectTypeResourceToJSON(value?: ProjectTypeResource | null): any {
    return value as any;
}

